/**
 * WssPowerBISection Component
 * Renders PowerBI reports based on sales group code
 */

import React from "react";
import PowerBi from "@pages/PowerBi";
import { POWERBI_SALES_GROUPS, POWERBI_REPORTS } from "../utils/wssConstants";

const WssPowerBISection = ({ salesGroupCode, customerCode }) => {
  const salesGroup = Number(salesGroupCode);

  // Check if sales group is in standard speedometer list
  const showStandardSpeedometer = POWERBI_SALES_GROUPS.STANDARD_SPEEDOMETER.includes(salesGroup);

  // Check if sales group is in MNT & ASF speedometer list
  const showMNTASFSpeedometer = POWERBI_SALES_GROUPS.MNT_ASF_SPEEDOMETER.includes(salesGroup);

  return (
    <>
      {/* My WSS Report (shown to all users) */}
      <div className="px-4 py-2.5">
        <PowerBi
          id={POWERBI_REPORTS.MY_WSS.id}
          pageName={POWERBI_REPORTS.MY_WSS.pageName}
          wssCode={customerCode}
        />
      </div>

      {/* WSS Speedometer (for specific sales groups) */}
      {showStandardSpeedometer && (
        <div className="px-4 py-2.5">
          <PowerBi
            id={POWERBI_REPORTS.WSS_SPEEDOMETER.id}
            pageName={POWERBI_REPORTS.WSS_SPEEDOMETER.pageName}
            wssCode={customerCode}
          />
        </div>
      )}

      {/* WSS Speedometer - MNT & ASF (for different sales groups) */}
      {showMNTASFSpeedometer && (
        <div className="px-4 py-2.5">
          <PowerBi
            id={POWERBI_REPORTS.WSS_SPEEDOMETER_MNT_ASF.id}
            pageName={POWERBI_REPORTS.WSS_SPEEDOMETER_MNT_ASF.pageName}
            wssCode={customerCode}
          />
        </div>
      )}
    </>
  );
};

export default WssPowerBISection;
